module.exports = __webpack_public_path__ + "7747046a72a9ccb05257ad4126cf1c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/email.png
// module id = 759
// module chunks = 2